import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { DeviceConfigurerServiceSharedModule } from '../../shared';
import { DeviceConfigurerServiceAdminModule } from '../../admin/admin.module';

import {
    SellerService,
    SellerPopupService,
    SellerComponent,
    SellerDetailComponent,
    SellerDialogComponent,
    SellerPopupComponent,
    SellerDeletePopupComponent,
    SellerDeleteDialogComponent,
    sellerRoute,
    sellerPopupRoute,
    SellerResolvePagingParams,
} from './';
import {SellerAddDialogComponent} from './seller-add-dialog.component';
import {SellerAddPopupComponent} from './seller-add-dialog.component';

let ENTITY_STATES = [
    ...sellerRoute,
    ...sellerPopupRoute,
];

@NgModule({
    imports: [
        DeviceConfigurerServiceSharedModule,
        DeviceConfigurerServiceAdminModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true }),
    ],
    declarations: [
        SellerComponent,
        SellerDetailComponent,
        SellerDialogComponent,
        SellerDeleteDialogComponent,
        SellerPopupComponent,
        SellerDeletePopupComponent,
        SellerAddDialogComponent,
        SellerAddPopupComponent
    ],
    entryComponents: [
        SellerComponent,
        SellerDialogComponent,
        SellerPopupComponent,
        SellerDeleteDialogComponent,
        SellerDeletePopupComponent,
        SellerAddDialogComponent,
        SellerAddPopupComponent
    ],
    providers: [
        SellerService,
        SellerPopupService,
        SellerResolvePagingParams,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DeviceConfigurerServiceSellerModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/seller/seller.module.ts